import { render, staticRenderFns } from "./chartOTPPurchase.vue?vue&type=template&id=13e28a0a&scoped=true&"
import script from "./chartOTPPurchase.vue?vue&type=script&lang=js&"
export * from "./chartOTPPurchase.vue?vue&type=script&lang=js&"
import style0 from "./chartOTPPurchase.vue?vue&type=style&index=0&id=13e28a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e28a0a",
  null
  
)

export default component.exports
import {QCard,QCardSection,QBar,QBtnDropdown,QInput,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QBar,QBtnDropdown,QInput,QBtn}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
